import React from 'react'
import Tipos from './inc/Tipos';
import Ventajas from './inc/Ventajas';
import Intro from '../inc/Intro';

export default function Inicio() {
    return (
        <div>
            <Intro/>
            <Tipos />
            <Ventajas />
        </div>
    )
}
